






















































import { dateFormatYYYYMMDD, dateTransactionFormat } from '@/constants';
import {
  OpenCancelScheduledDepositScreen,
  OpenUpdateScheduledDepositScreen,
} from '@/mixins/get-content-mixins';
import { ExtendMixins, LoadingService } from '@/services';
import { EventBus } from '@/event-bus';
import { ScheduledTransactionResponseModel } from '@/@types/member';

export default ExtendMixins(
  OpenCancelScheduledDepositScreen,
  OpenUpdateScheduledDepositScreen,
).extend({
  name: 'ScheduledTransactions',
  data() {
    return {
      dateFormatYYYYMMDD,
      dateTransactionFormat,
    };
  },
  props: {
    /**
     * The scheduled transactions for the selected account.
     */
    transactions: {
      type: Array as () => ScheduledTransactionResponseModel[],
      required: true,
    },
  },
  methods: {
    updateScheduledDeposit(selectedItem): void {
      const promises = this.$store.dispatch(
        'getSingleScheduledTransaction',
        selectedItem.scheduledDepositId,
      );
      LoadingService.watchPromises(promises)
        .then(() => {
          this.openUpdateScheduledDepositScreen({
            accountId: this.$route.params.id,
          });
        })
        .catch(() => {
          EventBus.$emit('openModal', 'Error', {
            message: 'update-scheduled-deposit_error-message',
            action: {
              label: 'global_try-again',
              performAction: () => {
                this.updateScheduledDeposit(selectedItem);
              },
            },
          });
        });
    },
    showCancelScheduledDepositModal(selectedItem): void {
      this.openCancelScheduledDepositScreen({
        transactionId: selectedItem.scheduledDepositId,
      });
    },
    isCancelable(item): boolean {
      return item.transactionType === 'Deposit';
    },
    isUpdatable(item): boolean {
      return item.transactionType === 'Deposit';
    },
    isActionable(item): boolean {
      return this.isCancelable(item) || this.isUpdatable(item);
    },
  },
});
